import { render, staticRenderFns } from "./salesReturnsPayment.vue?vue&type=template&id=898165a6&scoped=true&"
import script from "./salesReturnsPayment.vue?vue&type=script&lang=js&"
export * from "./salesReturnsPayment.vue?vue&type=script&lang=js&"
import style0 from "./salesReturnsPayment.vue?vue&type=style&index=0&id=898165a6&lang=less&scoped=true&"
import style1 from "./salesReturnsPayment.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898165a6",
  null
  
)

component.options.__file = "salesReturnsPayment.vue"
export default component.exports